<template>
    <div class="__dragster" style="clear: both">
        <slot></slot>
    </div>
</template>
<script>
    require('dragster')

    export default {
        name: 'dragster',
        props: {
            enter: {
                type: Function
            },
            leave: {
                type: Function
            }
        },
        ready () {
            this.dragster = new window.Dragster(this.$el)

            this.$el.addEventListener('dragster:enter', this.handleEnter)
            this.$el.addEventListener('dragster:leave', this.handleLeave)
        },
        beforeDestroy () {
            this.$el.removeEventListener('dragster:enter', this.handleEnter)
            this.$el.removeEventListener('dragster:leave', this.handleLeave)

            this.dragster.removeListeners()
        },
        methods: {
            handleEnter () {
                if (this.enter) {
                    this.enter()
                }
            },
            handleLeave () {
                if (this.leave) {
                    this.leave()
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Dragster.vue?a4ddf698